import {
  FETCH_LOGIN_DETAILS,
  FETCH_LOGIN_DETAILS_SUCCESS,
  FETCH_LOGIN_DETAILS_FAILURE,
  FETCH_UNREGISTERED_EMPLOYEES,
  FETCH_UNREGISTERED_EMPLOYEES_SUCCESS,
  FETCH_UNREGISTERED_EMPLOYEES_FAILURE,
  CREATE_LOGIN_USER_REQUEST,
  CREATE_LOGIN_USER_SUCCESS,
  CREATE_LOGIN_USER_FAILURE,
  RESET_PASSWORD_REQUEST, 
  RESET_PASSWORD_SUCCESS, 
  RESET_PASSWORD_FAILURE,
  TOGGLE_USER_STATUS_REQUEST,
  TOGGLE_USER_STATUS_SUCCESS,
  TOGGLE_USER_STATUS_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  FETCH_ROLES_REQUEST,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAILURE,
  FETCH_ACCESS_RIGHTS_REQUEST,
  FETCH_ACCESS_RIGHTS_SUCCESS,
  FETCH_ACCESS_RIGHTS_FAILURE,
  SAVE_ROLE_ACCESS_RIGHTS_REQUEST,
  SAVE_ROLE_ACCESS_RIGHTS_SUCCESS,
  SAVE_ROLE_ACCESS_RIGHTS_FAILURE,
  FETCH_MODULES_FAILURE,
  FETCH_MODULES_SUCCESS,
  FETCH_MODULES_REQUEST,
  SAVE_MODULE_REQUEST,
  SAVE_MODULE_SUCCESS,
  SAVE_MODULE_FAILURE,
  DELETE_MODULE_REQUEST,
  DELETE_MODULE_SUCCESS,
  DELETE_MODULE_FAILURE,
  FETCH_CONFIGURATION_SETUP_SUCCESS,
  FETCH_CONFIGURATION_SETUP_FAILURE,
  SAVE_CONFIGURATION_SETUP_REQUEST,
  SAVE_CONFIGURATION_SETUP_SUCCESS,
  SAVE_CONFIGURATION_SETUP_FAILURE,
  FETCH_CONFIGURATION_SETUP_REQUEST,
} from "./actionTypes";

const initialState = {
  loginDetails: [],
  unregisteredEmployees: [],
  loginLoading: false, // Separate loading for login details
  unregisteredEmployeesLoading: false, // Separate loading for unregistered employees
  roles: [],
  accessRights: [],
  modulesList:[],
  setupList: [],
  error: null,
  loading:false,
  success:false,
  successMessage: "",
};

const loginCreation = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOGIN_DETAILS:
      return { ...state, loginLoading: true };
    case FETCH_LOGIN_DETAILS_SUCCESS:
      return { ...state, loginLoading: false, loginDetails: action.payload.data };
    case FETCH_LOGIN_DETAILS_FAILURE:
      return { ...state, loginLoading: false, error: action.payload };

    case FETCH_UNREGISTERED_EMPLOYEES:
      return { ...state, unregisteredEmployeesLoading: true };
    case FETCH_UNREGISTERED_EMPLOYEES_SUCCESS:
      return { ...state, unregisteredEmployeesLoading: false, unregisteredEmployees: action.payload.data };
    case FETCH_UNREGISTERED_EMPLOYEES_FAILURE:
      return { ...state, unregisteredEmployeesLoading: false, error: action.payload };

    case CREATE_LOGIN_USER_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case CREATE_LOGIN_USER_SUCCESS:
      return { ...state, loading: false, success: true };

    case CREATE_LOGIN_USER_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    case RESET_PASSWORD_REQUEST:
      return { ...state, loading: true, success: false, error: '', successMessage: '' };

    case RESET_PASSWORD_SUCCESS:
      return { ...state, loading: false, success: true, successMessage: action.payload, error: '' };

    case RESET_PASSWORD_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload, successMessage: '' };

    case TOGGLE_USER_STATUS_REQUEST:
      return { ...state, loading: true, success: false, error: null };
    
    case TOGGLE_USER_STATUS_SUCCESS:
      return { ...state, loading: false, success: true, successMessage: action.payload, error: '' };;

    case TOGGLE_USER_STATUS_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    case CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        successMessage: "",
        error: "",
      };

    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.payload,
        error: "",
      };

    case CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        successMessage: "",
        error: action.payload,
      };

     // 🔹 Roles
    case FETCH_ROLES_REQUEST:
      return { ...state, loading: true, error: null, success:false };
    case FETCH_ROLES_SUCCESS:
      return { ...state, loading: false, roles: action.payload.data, success:false };
    case FETCH_ROLES_FAILURE:
      return { ...state, loading: false, error: action.payload, success:false };

    // 🔹 Access Rights
    case FETCH_ACCESS_RIGHTS_REQUEST:
      return { ...state, loading: true, accessRights: [], error: null, success:false };
    case FETCH_ACCESS_RIGHTS_SUCCESS:
      return { ...state, loading: false, accessRights: action.payload.data, success:false };
    case FETCH_ACCESS_RIGHTS_FAILURE:
      return { ...state, loading: false, error: action.payload, success:false };

    case SAVE_ROLE_ACCESS_RIGHTS_REQUEST:
      return { ...state, loading: true, error: null, success:false };

    case SAVE_ROLE_ACCESS_RIGHTS_SUCCESS:
      return { ...state, loading: false, response: action.payload, success:true };

    case SAVE_ROLE_ACCESS_RIGHTS_FAILURE:
      return { ...state, loading: false, error: action.payload, success:false };

    case FETCH_MODULES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success:false
      };

    case FETCH_MODULES_SUCCESS:
      return {
        ...state,
        loading: false,
        modulesList: action.payload.data || [],
        success:false
      };

    case FETCH_MODULES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success:false
      };

    case SAVE_MODULE_REQUEST:
      return { ...state, loading: true, error: null,success:false };
    case SAVE_MODULE_SUCCESS:
      return { ...state, loading: false, data: action.payload,success:true };
    case SAVE_MODULE_FAILURE:
      return { ...state, loading: false, error: action.payload,success:false };

    case DELETE_MODULE_REQUEST:
      return { ...state, loading: true, error: null,success:false };

    case DELETE_MODULE_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteResponse: action.payload,success:true
      };

    case DELETE_MODULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,success:false
      };

    case FETCH_CONFIGURATION_SETUP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case FETCH_CONFIGURATION_SETUP_SUCCESS:
      return {
        ...state,
        loading: false,
        setupList: action.payload.data || [],
        success: false,
      };

    case FETCH_CONFIGURATION_SETUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case SAVE_CONFIGURATION_SETUP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case SAVE_CONFIGURATION_SETUP_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        success: true,
      };

    case SAVE_CONFIGURATION_SETUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    default:
      return state;
  }
};

export default loginCreation;
